import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CoreState } from 'src/app/state/_state.interfaces';
import { Store } from '@ngrx/store';
import { getSession } from 'src/app/state/_state.selectors';
import { map } from 'rxjs/operators';
import { HOME_URL } from 'src/app/app.config';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  islogin$: Observable<boolean>;

  constructor(
    private router: Router,
    private session: Store<CoreState>
  ) {
    this.islogin$ = this.session.select(getSession).pipe(map(store => store.login));
  }

  // ログイン画面に戻る(非ログイン状態)
  moveLoginPage() {
    this.router.navigate(['login']);
  }

  // ホーム画面に戻る(ログイン状態)
  moveHomePage() {
    this.router.navigate([HOME_URL]);
  }
}
